export class BaseResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    additionalInformation?: string | undefined;
}

export class StringBaseResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    additionalInformation?: string | undefined;
    result?: string | undefined;
}

export class StringListBaseResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    additionalInformation?: string | undefined;
    result?: string[] | undefined;
}
